import './emptyContent.scss'
import {useSelector} from 'react-redux'
import classNames from 'classnames'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const EmptyComponent = ({openModal, zapierTypeIcons, integrationOptions}) => {
    const mobileWidth = 576
    const isMobile = window.innerWidth < mobileWidth
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const text = useNamespaceTranslations('integrations')
    const zapierTypes = useNamespaceTranslations('zapier-types')

    return (
        <div className={classNames('empty-team-integrations', {
            dark: isDarkMode
        })}>
            <div className={classNames('integration-container', {
                dark: isDarkMode
            })}>
                <div className="info">
                    <h3>
                        <span className="text">{text.choose_way}</span>{' '}
                        <span className="text">{text.to_integrate}</span>
                    </h3>
                    <p>{text.empty_content_desc}</p>
                </div>
                <div className="content">
                    {integrationOptions.map(item => (
                        <div className="card" key={item.type} onClick={() => openModal(item)}>
                            <span className="icon">{item.icon}</span>
                            <span className="label">{item.name}</span>
                        </div>
                    ))}
                    {zapierTypes.types.map(item => (
                        <div className="card" key={item.type} onClick={() => openModal(item)}>
                            <span className="icon">{zapierTypeIcons[item.type]}</span>
                            <span className="label">{isMobile ? item.short_label : item.label}</span>
                            <span className="zap">{text.zapier}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default EmptyComponent
